import { Component } from "react";
import ThemeableAgGrid from "../../../common/components/agGrid/ThemeableAgGrid";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

class TradingMarketsTable extends Component {
  columnDefs = [
    {
      name: "name",
      field: "name",
      headerName: this.props.t("Market"),
      sortable: true,
      filter: true,
      flex: 2,
    },
    {
      name: "halted",
      headerName: this.props.t("Halted"),
      sortable: true,
      filter: true,
      flex: 1,
      headerClass: "ag-center-aligned-header",
      cellRenderer: (params) => {
        const isActive = params.data?.halted;
        return (
          <div className="centered" style={{ width: "100%", height: "100%" }}>
            <FontAwesomeIcon
              icon={isActive ? faCheck : faTimes}
              className={isActive ? "text-success" : "text-danger"}
              style={{ fontSize: "16px" }}
            />
          </div>
        );
      },
    },
    {
      name: "allowPick",
      headerName: this.props.t("AllowPick"),
      sortable: true,
      filter: true,
      flex: 1,
      headerClass: "ag-center-aligned-header",
      cellRenderer: (params) => {
        const isActive = params.data?.allowPick;
        return (
          <div className="centered" style={{ width: "100%", height: "100%" }}>
            <FontAwesomeIcon
              icon={isActive ? faCheck : faTimes}
              className={isActive ? "text-success" : "text-danger"}
              style={{ fontSize: "16px" }}
            />
          </div>
        );
      },
    },
    {
      name: "allowAllOrNone",
      headerName: this.props.t("AllowAllOrNone"),
      sortable: true,
      filter: true,
      flex: 1,
      headerClass: "ag-center-aligned-header",
      cellRenderer: (params) => {
        const isActive = params.data?.allowAllOrNone;
        return (
          <div className="centered" style={{ width: "100%", height: "100%" }}>
            <FontAwesomeIcon
              icon={isActive ? faCheck : faTimes}
              className={isActive ? "text-success" : "text-danger"}
              style={{ fontSize: "16px" }}
            />
          </div>
        );
      },
    },
    {
      name: "allowFillOrKill",
      headerName: this.props.t("AllowFillOrKill"),
      sortable: true,
      filter: true,
      flex: 1,
      headerClass: "ag-center-aligned-header",
      cellRenderer: (params) => {
        const isActive = params.data?.allowFillOrKill;
        return (
          <div className="centered" style={{ width: "100%", height: "100%" }}>
            <FontAwesomeIcon
              icon={isActive ? faCheck : faTimes}
              className={isActive ? "text-success" : "text-danger"}
              style={{ fontSize: "16px" }}
            />
          </div>
        );
      },
    },
    {
      name: "withdrawOnCrossTrade",
      headerName: this.props.t("WithdrawOnCrossTrade"),
      sortable: true,
      filter: true,
      flex: 1,
      headerClass: "ag-center-aligned-header",
      cellRenderer: (params) => {
        const isActive = params.data?.withdrawOnCrossTrade;
        return (
          <div className="centered" style={{ width: "100%", height: "100%" }}>
            <FontAwesomeIcon
              icon={isActive ? faCheck : faTimes}
              className={isActive ? "text-success" : "text-danger"}
              style={{ fontSize: "16px" }}
            />
          </div>
        );
      },
    },
    {
      name: "applyCounterpartyWhitelist",
      headerName: this.props.t("ApplyCounterpartyWhitelist"),
      sortable: true,
      filter: true,
      flex: 1,
      headerClass: "ag-center-aligned-header",
      cellRenderer: (params) => {
        const isActive = params.data?.applyCounterpartyWhitelist;
        return (
          <div className="centered" style={{ width: "100%", height: "100%" }}>
            <FontAwesomeIcon
              icon={isActive ? faCheck : faTimes}
              className={isActive ? "text-success" : "text-danger"}
              style={{ fontSize: "16px" }}
            />
          </div>
        );
      },
    },
    {
      name: "active",
      headerName: this.props.t("Active"),
      sortable: true,
      filter: true,
      flex: 1,
      headerClass: "ag-center-aligned-header",
      cellRenderer: (params) => {
        const isActive = params.data?.active;
        return (
          <div className="centered" style={{ width: "100%", height: "100%" }}>
            <FontAwesomeIcon
              icon={isActive ? faCheck : faTimes}
              className={isActive ? "text-success" : "text-danger"}
              style={{ fontSize: "16px" }}
            />
          </div>
        );
      },
    },
  ];

  render() {
    const { tradingMarkets, onRowClick } = this.props;

    // Pagination configuration
    const paginationConfig = {
      // Enable pagination for all tables regardless of size
      enabled: true,
      // Default page size
      pageSize: 20,
      // Available page size options for user to choose
      pageSizeOptions: [5, 10, 20, 50, 100],
    };

    return (
      <ThemeableAgGrid
        className="table-bold clickable"
        columnDefs={this.columnDefs}
        rowData={tradingMarkets}
        onRowClicked={(params) => onRowClick && onRowClick(params.data)}
        getRowId={(params) => params.data.marketId.toString()}
        animateRows={true}
        domLayout="autoHeight"
        pagination={true}
        paginationPageSize={paginationConfig.pageSize}
        paginationPageSizeSelector={paginationConfig.pageSizeOptions}
        suppressPaginationPanel={false}
      />
    );
  }
}

export default withTranslation(["trading"])(TradingMarketsTable);

